import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "ssg-dialog-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ssg-dialog-content prefix" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("h5", { class: "title" }, " 진행 일정 "),
      /*#__PURE__*/_createElementVNode("div", { class: "item-row" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "name prefix" }, " 모집 : "),
        /*#__PURE__*/_createElementVNode("div", { class: "content" }, " 2023년 6월 5일(월) ~ 6월 19일(월) ")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "item-row" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "name prefix" }, " 발표 : "),
        /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
          /*#__PURE__*/_createElementVNode("div", null, "2023년 6월 21일(수)"),
          /*#__PURE__*/_createElementVNode("div", null, "* 당첨자에 한해 운영사무국에서 개별 안내 드립니다.")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "item-row" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "name prefix" }, " 참여/수거 : "),
        /*#__PURE__*/_createElementVNode("div", { class: "content" }, " 2023년 6월 23일(금) ~ 8월 23일(수) ")
      ]),
      /*#__PURE__*/_createElementVNode("p", { class: "prefix" }, " 온라인 참여 신청/당첨 안내 및 수거 등 전반적인 운영은 테라사이클에서 대행하여 진행합니다. "),
      /*#__PURE__*/_createElementVNode("p", { class: "prefix" }, " 수거된 박스는 글로벌 재활용 혁신 기업 테라사이클이 종이팩과 박스 모두 재활용합니다. "),
      /*#__PURE__*/_createElementVNode("p", { class: "prefix" }, [
        /*#__PURE__*/_createTextVNode(" 테라사이클 팀은 여러분이 보내 주신 모든 박스를 하나 하나 검수하여 올바른 방법으로"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("참여해주신 분들에게만 리워드를 보내 드립니다. ")
      ]),
      /*#__PURE__*/_createElementVNode("p", { class: "prefix" }, " 올바른 분리배출 방법은 페이지 <종이팩 올바른 분리배출법> 부분을 참고해주시길 바랍니다. "),
      /*#__PURE__*/_createElementVNode("p", { class: "prefix" }, " 수거 신청 마감 일정을 반드시 준수해주세요. "),
      /*#__PURE__*/_createElementVNode("p", { class: "prefix" }, " 리워드 미제공 대상자(탈락자)의 경우 마이페이지 상에서 확인이 가능하며, 별도 안내 메시지가 발송되지 않습니다. "),
      /*#__PURE__*/_createElementVNode("p", { class: "prefix" }, " 경품 발송을 위한 개인정보 수집 및 경품 발송은 테라사이클에서 대행합니다. "),
      /*#__PURE__*/_createElementVNode("p", { class: "prefix" }, " 부정한 방법으로 캠페인에 참여한 것이 발견될 경우, 발표일 이후에도 당첨이 취소될 수 있습니다. "),
      /*#__PURE__*/_createElementVNode("p", { class: "prefix" }, " 이벤트에 대한 세부사항 및 경품내용은 당사 사정에 의해 조기 종료 및 변경될 수 있습니다. "),
      /*#__PURE__*/_createElementVNode("p", { class: "flex-wrap prefix" }, [
        /*#__PURE__*/_createTextVNode(" 기타 궁금한 사항은 "),
        /*#__PURE__*/_createElementVNode("a", {
          class: "mailto",
          href: "mailto:customersupport.kr@terracycle.com"
        }, "customersupport.kr@terracycle.com"),
        /*#__PURE__*/_createTextVNode("로 메일 문의 부탁 드립니다. ")
      ])
    ])
  ])
], -1)

import { ref } from 'vue';
import './dialog.scss';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const dialogVisible = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_AppDialog = _resolveComponent("AppDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogVisible.value = true))
    }, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createVNode(_component_AppDialog, {
      visible: dialogVisible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
      class: "ssg-dialog",
      btns: [],
      title: "유의사항"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})